<template>
    <div class="it365-janqi-com-wrapper">

        <section class="it365-janqi-com" style="padding: 72pt 90pt; width: 595.3pt; min-height: 841.9pt;">
            <article style="column-count: 1; column-gap: 21.25pt;">
                <p style="text-align: center;"><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; min-height: 14pt; font-size: 14pt;">窝窝投</span><span
                        lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; min-height: 14pt; font-size: 14pt;">隐私政策</span>
                </p>
                <p style="text-align: center;"></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">生效日期：2025年01月01日</span></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">最近更新：2025年</span><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font);">11</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">月</span><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font);">24</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">日</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">引言</span></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">窝窝投（下称“我们”）</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">尊重并保护所有平台用户的个人信息及隐私安全。为给用户（下称“您”）提供更准确、有个性化的服务及更安全的互联网环境，我们依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》以及其他相关法律法规和技术规范明确了我们收集/使用/对合作方/关联方/合作商家提供您个人信息的原则，制定</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">《窝窝投网络服务平台用户个人信息保护政策》（下称“本政策”）</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">本政策与您通过我们窝窝投网络服务平台（下称“平台”）与平台认证商家进行合作，或使用的我们的服务或产品息息相关，您在下载、安装、启动、浏览、注册、登录、使用我们的服务或产品时，我们将按照本政策的约定处理和保护您的个人信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">鉴于本平台的设立初衷，您明确知晓并确认授权我们抓取您在您认证、授权的各个平台（如：抖音、今日头条）的数据，包括但不限于：粉丝数、作品、点赞、评论、转发、收藏、曝光等数据。您认可我们在您认证的各个平台抓取的数据，如对数据存在质疑，您应与相关平台沟通，我们不对数据真实性负责，您亦无权要求我们修改数据。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">我们以尽快能简明扼要的表述向您解释本政策所涉及的词汇，以便于您理解。</span>
                </p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">本政策中与您权益（可能）存在重大关系的条款，我们已使用加粗字体予以区别，请您重点查阅。本政策不适用于未满18周岁的未成年人，因您并非平台的适格注册用户。&nbsp;</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">
                        请您在通过我们平台与平台认证商家进行合作或使用或继续使用我们的各项服务与产品前，仔细阅读并充分理解本政策，并在需要时，按照本政策的指引，做出适当的选择。如果您不同意本政策的内容，您应立即停止使用我们的服务或/及产品。您通过我们平台与平台认证商家进行合作或使用或继续使用我们提供的服务或/及产品的行为，均表示您充分理解并同意本政策（包括我们根据实际需要不时更新的版本）的全部内容。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">
                        在您确认同意本政策的内容后，我们将根据本政策的约定申请获取您的个人信息。</span></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);"> 关于我们 </span></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">窝窝投网络服务平台（包括但不限于网页版、桌面版、移动版软件客户端及小程序）的经营者为</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">上海德益文智能科技有限公司</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，公司注册地址为上海市徐汇区宜山路900号A座1510室</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">&nbsp;</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);"> </span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">本政策将帮助您了解到： </span></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">1、&nbsp;&nbsp;我们会遵循本政策收集、使用您的信息，但不会仅因您同意本政策而采用强制捆绑的方式一揽子收集、使用您的个人信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">2、&nbsp;&nbsp;当您使用服务或开启相关功能时，为实现服务、功能所必需，我们会收集、使用相关信息。除非是为实现基本服务（功能）或根据法律法规要求所必需的必要信息，您均可拒绝提供且不影响其他服务（功能）。我们将在本政策中逐项说明哪些是必要信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">3、&nbsp;&nbsp;如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了帐号，我们会根据帐号信息实现信息推送。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">4、如果您有相关账号，APP内提供注销按钮，注销申请提交成功后，会在10个工作日内完成注销审核。审核通过后，窝窝投即刻永久性注销该账户。审核未通过，窝窝投将通过电话、邮件等多种方式提示用户未能通过的原因。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">注销账号功能途径：进入我的，选择右上角齿轮设置按钮，选择注销账户点击进去填写注销原因与注销理由，填写完毕之后点击立即注销。注销申请提交成功后，我们会在10个工作日内完成注销审核。审核通过后，窝窝投即刻永久性注销该账户。审核未通过，窝窝投将通过电话、邮件等多种方式提示用户未能通过的原因。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">我的\-设置\-注销账号\-写注销理由\-立即注销\-等待审核。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">5、&nbsp;&nbsp;为帮您发现更多朋友，我们可能会申请通讯录权限。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">6、&nbsp;&nbsp;通讯录、精确地理位置、摄像头、麦克风、相册权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可随时撤回授权。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，但我们并不会在实现相关服务（功能）不必要时而收集您的信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">&nbsp;</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">下文十一个部分将快速帮您详细了解我们如何收集、使用、存储、传输、共享、转让（如适用）与保护您的个人信息，帮您了解查询、访问、删除、更正、撤回授权个人信息的方式。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">&nbsp;</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">目录</span></p>
                <p></p>
                <p class="it365-janqi-com-num-1-0"><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">我们如何收集及使用您的个人信息</span>
                </p>
                <p class="it365-janqi-com-num-0-undefined"></p>
                <p class="it365-janqi-com-num-1-0"><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">第三方SDK信息共享说明</span></p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">三</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、我们如何使用Cookie及其他同类技术</span>
                </p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">四</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、我们如何共享、转让、公开披露您的个人信息</span>
                </p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">五</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、我们如何保存及保护您的个人信息</span>
                </p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">六</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、您的权利</span></p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">七</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、您的个人信息如何进行跨境转移</span>
                </p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">八</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、本政策的更新</span></p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">九</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、联系我们</span></p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">十</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、争议解决</span></p>
                <p></p>
                <p><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">十一</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">、附录：定义</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">&nbsp;</span></p>
                <p></p>
                <p class="it365-janqi-com_3"><span>一、我们如何收集及使用您的个人信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集及使用您通过平台与平台认证商家进行合作，或使用的我们的服务或产品中主动提供或因与平台认证商家进行合作，或使用我们服务或产品而产生的个人信息。如果我们需要将您的个人信息用于本政策未载明的其它用途，或基于特定目的将已经收集的信息用于其他目的，我们将以合理的方式告知您，事先征得您的同意：</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_4"><span>(一)基本功能及相关必要个人信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">在您使用窝窝投提供的以下服务（功能）过程中，我们将收集以下必要的相关个人信息，以及部分您选择提供的个人信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">1.注册账号</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您首先需要注册一个窝窝投账号成为窝窝投的注册用户。当您注册时，您至少需要向我们提供您本人的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">手机号码</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，我们将通过发送</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">短信验证码</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">的方式来验证您的身份信息。如果您不提供这些信息，不影响您浏览、搜索平台公开的内容。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">由于涉及</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">实名认证</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，若您使用非本人的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">手机号码</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">进行注册可能会导致您后续使用相应功能时产生障碍，因此，请确保您所使用的手机号码系您本人的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">手机号码</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">您还可根据自身需求选择填写</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">性别、出生年月日、所在地区及个人介绍</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">等来完善您的信息。但如您拟进行</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">实名认证</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，则需要填写完整、真实的相关信息。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">如果您成功注册窝窝投账号，我们会在窝窝投平台中显示您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">用户名、头像、地区、个人介绍</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">等信息。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">2.实名认证</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">为满足网络实名制要求，在您通过我们平台与平台认证商家进行合作或使用发布、评论及其他要求实名认证的服务与功能前，我们将在征得您同意的前提下，
                        收集您的居民</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">身份证</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">以完成实名认证。并且，为了向您提供更好的产品/服务和体验，我们会将您的实名认证信息，包括</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">姓名、身份证号、手机号码</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">或</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">银行卡号</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，提供给我们委托的第三方服务机构，用于验证您所提供的认证信息的真实性。您理解并同意，我们合作的第
                        三方服务机构可能会将您的信息用于外部合法数据库的比对，以获得验证结果。为了确保您的信息安全，我们会要求第三方合作机构具备足够的数据安全能力，并提供足够的安全保护水平。未经您的同意，我们不会将您提供的信息用于未经您明确授权的其他用途。请您谨慎考虑后提供这类信息，若您拒绝提供，您可能无法使用相应的服务（功能）。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">3.完善在线信息</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">在您注册成功后，首先您需要完善</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">个人信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">、</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">标签</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">等信息。窝窝投将根据您的以上信息，利用算法为您推荐可能合适您的任务。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">4.推荐服务</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">(1)您可通过窝窝投的推荐页，浏览到可能会满足您的需求或期望的任务信息或</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">平台认证</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">商家。我们会保留您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">关键词</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">搜索，避免您重复输入并为您展示与您搜索内容相关的任务或/及</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">平台认证</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">商家。请您注意，当您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">关键词</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">搜索与您的其他信息相互结合使用并可能识别您的身份时，我们会将您的搜索关键词信息作为您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">个人信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，与您的关键词搜索记录一同按照本政策对其进行</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">处理与保护</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(2)我们会在得到您授权同意后，访问您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold; color: rgb(0, 0, 255);">位置信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">用于计算</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">任务距离</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，作为向您推荐任务的重要依据。如不提供，我们</span><span
                        lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font);">无法为您提供探店任务，仅能推荐推广任务</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(3)我们会通过您填写的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">认证平台、探店打卡经历、推广经历、带货经历</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，结合您的操作记录（如搜</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">索、浏览、关注、收藏及聊天</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">）等形成您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">个人画像</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，为您获取相关任务信息并将您推荐给平台认证商家。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">温馨提示：窝窝投无法保证推荐算法的绝对精准，也无法确保您百分百满意窝窝投的推荐服务，无论有偿或是免费。如果您对算法推荐的任务信息有任何不满的，可通过人工客服向我们反馈您的意见。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">5.任务</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(1)当您在使用窝窝投时，我们将您推荐给平台认证商家时，需要展示您的个人画像。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(2)当平台认证商家需要给您寄送商品时，窝窝投将获取您提供的地址信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(3)您发布在相关平台的链接及平台相关的数据，商家有权通过窝窝投进行调阅。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(4)当你按照任务要求提交稿件后，商家可能会审阅您的稿件并在不改变您原有意思的情况下进行修订。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(5)当平台认证商家在线上审核通过，窝窝投将向您进行转账以便您获得任务推广费，此时将会涉及您的个人银行或其他账户信息。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（二）改进产品和保障任务安全的相关信息</span></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">为增强窝窝投网络服务平台的发布任务、送审任务、获得推广服务费等过程中的安全性，尽可能保障您或其他用户在完成任务过程中的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">人身、财产安全</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">免遭侵害，我们会收集必要的不涉及到您个人身份等隐私的信息，包括：</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;我们可能会收集您网络服务相关的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">日志信息及设备信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，如</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">IP地址、某按钮的点击使用时间和频率</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">、某页面的使用</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">时间和频率</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">、某些关键</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">配置的选项值、崩溃日志、错误日志、应用安装列表信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，用于将您感兴趣的任务、平台认证商家或寻找任务过程中您可能需要的服务信息展示给您，同时有可能用于统计使用我们平台服务或/及产品的用户数量、分析服务或/及产品的使用状况、网页升级改版、浏览器兼容性检测、排查崩溃原因、减少崩溃情况、打击违法违规行为及防止平台用户个人信息泄露。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;为保护您的账号安全，我们会在取得您的授权同意后，访问您的设备标识信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;为验证您的身份信息，防止他人未经授权访问您的帐号，我们会在取得您的授权同意后，访问您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">设备标识信息、微信账号</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，如您需要使用提现等功能，否则将无法利用身份信息验证的方式保障您的账户安全。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（三）需要您授权同意调取系统权限的情形</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.基于保护完成任务过程中的用户人身安全之考虑，以及满足互联网平台服务普遍存在的风控需求，窝窝投的附加业务功能可能需要您先同意我们调取相关的系统权限以使用您的个人</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: normal; color: black;">信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（四）通过第三方收集信息的情形</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.为保障我们平台的稳定运行、服务（功能）实现，使您能够更好地使用我们平台与平台认证商家进行合作、使用和体验更丰富的服务（功能），我们的应用中会</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">嵌入授权合作伙伴的SDK&nbsp;或其他类似的应用程序</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.我们会对前述</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">应用程序接口（API）、软件工具开发包（SDK）</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">及授权合作伙伴进行严格的安全检测，并约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.前述SDK包括</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">com\.tencent\.tpns\.plugin（腾讯移动推送
                        TPNS
                        SDK），com\.igexin\.sdk\(个推;个推推送;\)，com\.xiaomi\.mipush\(小米;小米推送\)，com\.getui\(个推;个数应用统计;个像\)，com\.huawei\.hms\(华为;华为推送\)，com\.vivo\(VIVO;VIVO推送\)，com\.huawei\.agconnect\(华为;华为联运应用\)系用于向您推送消息及任务状态。com\.amap\.api\(高德地图;高德导航;高德定位;阿里高德地图;高德\)系用于收集您与平台认证商家的位置详情，用于计算您与平台认证商家双方间的距离。友盟\+SDK，友盟\+SDK需要收集您的设备Mac地址、唯一设备识别码（IMEI/android
                        ID/IDFA/OPENUDID/GUID/IP地址/SIM 卡 IMSI
                        信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊能力。为了改善注册及登陆界面用户体验，集成第三方SDK一键登录服务：闪验SDK，用于帮助实现用户一键登录行为，移动推送TPNS读取特定类型传感器列表为了实现网关取号技术，需要获取您的IP地址、网卡（MAC\)地址、国际移动设备识别码（IMEI）、OAID（替代IMEI）、sim卡信息，并会收集您的手机机型、系统类型、系统版本、网络环境、网关取号报错日志等数据以提供统计分析服务能力，并可提供反欺诈等功能。关于闪验SDK采集终端用户数据的范围、用途及安全措施请参照创蓝闪验SDK运营方的隐私政策。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">4.</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">此外，当您通过本平台接入第三方服务时，您的信息将适用该第三方的隐私政策，建议您在接受相关服务前阅读并确认理解相关协议。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">5.在合乎法律规定或获得您的授权的前提下，对我们与之共享用户信息的公司、组织和个人，我们会与其签署严格的保密协议以及信息保护约定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理用户信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">6.APP运行自启动或关联启动权限说明：腾讯推送在网络变更、多应用协同场景下，为保障消息即时推送，依用户授权且最小化启动原则，自启动或关联启动应用，确保推送稳定必要。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（</span><span lang="en-US">五</span><span>）征得授权同意的例外</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">根据相关法律法规的规定，在以下情形中，我们可在不征得您授权同意的情况下收集、使用一些必要的个人信息：</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(1)与国家安全、国防安全直接相关的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(2)与公共安全、公共卫生、重大公共利益、社会公序良俗直接相关的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(4)出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(5)所收集的个人信息是您自行向社会公众公开的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(6)从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(7)根据您的要求签订和履行合同所必需的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(8)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(9)用于维护窝窝投网络服务平台服务或产品的安全稳定运行所必需的，包括发现、处置服务或产品的故障；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">(10)法律法规规定的其他情形。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">如果您对我们收集和使用您的个人信息有任何疑问或需要我们进一步说明的，请通过本政策公布的联系方式与我们联系。根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（</span><span lang="en-US">六</span><span>）收集的个人信息类型</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1. 当您使用本 APP
                        时，为了实现精准营销以及优化服务体验等目的，我们可能会收集您</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">设备的 MAC 地址</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。此信息主要用于识别您的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">设备唯一性</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，以便在不同网络环境下准确追踪您与我们 APP
                        的交互情况，同时辅助我们进行广告投放效果评估。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2. 我们还会收集您设备上的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">软件安装列表</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，包括已安装</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">应用程序的名称、版本号、安装时间以及应用来源渠道等信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。通过分析软件安装列表，我们能够深入了解您的兴趣偏好和消费习惯，从而为您提供更贴合您需求的产品推荐、促销活动信息以及市场调研相关服务。</span><span
                        id="_GoBack"></span></p>
                <p></p>
                <p class="it365-janqi-com_4"><span>（</span><span lang="en-US">七</span><span>）收集方式</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1. 在您首次安装并启动本 APP
                        时，我们会通过系统弹窗向您请求获取相关权限，其中包括读取设备信息权限以获取</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;"> MAC 地址</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">，以及</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">读取应用列表权限用于收集软件安装列表</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。只有在您明确同意授予这些权限后，我们才会进行相应信息的收集操作。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2. 部分功能可能依赖于我们集成的</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">第三方 SDK </span><span
                        style="font-family: var(--docx-minorEastAsia-font);">来实现信息收集。这些第三方 SDK
                        会在您使用相关功能时，遵循本隐私协议的规定以及相关法律法规要求，协助我们收集设备 MAC 地址和软件安装列表等信息。例如，\[列举部分第三方 SDK 名称\]SDK
                        会在特定场景下参与信息收集工作，但我们会严格监督其数据收集行为，确保其不会超出本协议约定的范围。</span></p>
                <p></p>
                <p class="it365-janqi-com_4"><span lang="en-US">（八）信息保护</span></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.
                        我们高度重视您个人信息的安全，采取多种技术手段和管理措施来保护您的信息免遭未经授权的访问、使用、修改或泄露。对于设备 MAC
                        地址和软件安装列表等信息，我们会采用加密存储、访问权限控制等安全措施，确保只有授权人员在合法的业务需求范围内才能访问和处理这些信息。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.
                        我们会定期对信息收集、存储和使用的安全措施进行评估与审查，及时发现并解决可能存在的安全隐患，保障您个人信息的安全性与完整性。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.
                        若发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知事件相关情况，包括事件的基本情况、可能的影响范围、已采取或即将采取的应对措施等，同时我们会积极配合相关监管部门的调查与处理工作，尽最大努力降低事件对您造成的影响。</span>
                </p>
                <p></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">信息收集</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1. 为了更好地实现本 APP
                        的功能以及为您提供个性化的服务和精准的营销内容，我们会收集</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">您设备的 IMEI（国际移动设备识别码）、设备
                        MAC 地址以及软件安装列表</span><span style="font-family: var(--docx-minorEastAsia-font);">等信息。设备 IMEI
                        可帮助我们识别您的移动设备唯一性，</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">设备 MAC 地址</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">有助于我们在不同网络环境下追踪您的设备交互情况，软件安装列表则能让我们深入了解您的应用使用偏好和潜在消费兴趣，以便为您定制更贴合您需求的产品推荐与营销方案。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">信息使用</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">1.
                        基于收集到的上述信息，我们将进行内部数据分析与整合，构建您的专属用户画像，以提升您在本 APP 内的使用体验，例如为您展示更符合您兴趣的广告、推荐合适的商品或服务等。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">2.
                        同时，我们会将部分信息与友盟、极光、个推等第三方 SDK 共享，用于实现特定的功能与服务拓展。</span></p>
                <p></p>
                <p class="it365-janqi-com_3"><span> 二、第三方 SDK 信息共享说明</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.第三方SDK来源：友盟</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">收集个人信息用途/目的：移动统计、性能监控</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">收集个人信息类型：设备信息、应用信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">第三方隐私政策链接：https://www.umeng.com/page/policy</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2. 第三方SDK来源：极光</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">SDK 用途：为 APP 用户提供信息推送服务</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">收集个人信息类型：设备参数及系统信息(设备类型、设备型号、系统版本、及相关硬件信息)：用于识别用户的设备类型、设备型号、系统版本等。用于方便用户应用安装、更新、卸载，并确保消息准确下发；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">设备标识符（IMEI、IDFA、Android
                        ID、GAID、MAC、OAID、VAID、AAID、IMSI、MEID、UAID、硬件序列号信息、ICCID、SIM信息）：用于识别唯一用户，保证推送的精准送达及推送信息的准确统计；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">网络信息(IP 地址、WiFi
                        信息、基站信息、DNS地址、DHCP地址、SSID、BSSID)与位置信息（经纬度）：用于优化SDK与极光服务器的网络连接请求，保证服务的稳定性和连续性，同时实现区域推送功能；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">应用列表信息(应用崩溃信息、通知开关状态、APP 应用列表及活跃状态、APP
                        应用页面信息、APP 功能事件相关信息)：当一个设备有多个 APP
                        的推送链路同时活跃时，我们采用合并链路技术，随机合并成一条链路，以达到为用户节省电省流量的目的。另极光推送存在静默状态获取设备信息。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">第三方隐私政策或官网链接：https://www.jiguang.cn/license/privacy</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3. 个推 SDK：与个推 SDK 的信息共享涉及您的设备 IMEI、MAC
                        地址及软件安装列表等内容，目的是通过个推 SDK 的智能推送技术，提高推送消息的送达率和精准度，确保您能及时收到对您有价值的信息，如限时优惠信息、专属福利推荐等。个推 SDK
                        的隐私政策可在\[个推官方隐私政策链接\]获取。</span></p>
                <p></p>
                <p><span lang="en-US" style="font-family: var(--docx-minorEastAsia-font);">4</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">\.Bugly（腾讯 Bugly 崩溃分析服务）</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">使用目的： 应用崩溃监控、错误分析、性能优化</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">收集个人信息类型：</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">设备标识信息：ICCID（部分设备可能上报）</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">设备标识：Android ID</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">其他崩溃日志相关信息</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">官网： https://bugly.qq.com</span></p>
                <p></p>
                <p><span lang="en-US" style="font-family: var(--docx-minorEastAsia-font);">5</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">\.中国电信 SDK</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">使用目的： 运营商认证、网络能力相关</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">收集个人信息类型：</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">设备标识：Android ID</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">官网：</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">https://www.189.cn</span></p>
                <p></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">信息保护与安全措施</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.
                        我们始终将您个人信息的安全放在首位，在信息收集、传输、存储和使用过程中，采用严格的加密技术、访问权限控制以及定期的安全审计等措施，保障您的信息不被未经授权的访问、使用、修改或泄露。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2. 对于与第三方 SDK
                        的信息共享，我们会严格筛选合作方，确保其具备相应的数据安全保护能力和合规运营资质。并且，我们会与第三方 SDK
                        提供商签订详细的数据保护协议，明确规定其对所接收数据的使用范围、安全保护责任以及数据留存期限等要求，监督其严格遵守相关法律法规和隐私政策约定。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.
                        若发生任何个人信息安全事件，我们将立即启动应急预案，及时通知您事件的相关情况，包括事件的性质、可能影响的范围、已采取或即将采取的应对措施等，并按照法律法规要求向相关监管部门报告，积极配合调查处理工作，尽最大努力降低事件对您造成的不利影响。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">信息收集方式</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1. 自动收集：当您使用本 APP
                        时，我们可能会通过技术手段自动收集上述个人信息。例如，在您首次启动本 APP 时，我们会通过设备系统权限请求获取相关设备信息；在您使用 APP
                        过程中，我们会自动记录您的一些操作行为数据，其中可能涉及到对软件安装列表信息的收集，以便我们能更全面地了解您的使用习惯与偏好，进而为您提供更优质、更贴合您需求的服务体验。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.
                        基于您的授权收集：在某些情况下，为了实现特定功能或服务，我们可能会请求您授予特定的权限，例如读取设备信息权限或访问应用列表权限。只有在您明确同意授予这些权限后，我们才会收集相应的个人信息。您有权随时在设备的系统设置中撤回对这些权限的授予，但请注意，撤回某些权限可能会影响本
                        APP 部分功能的正常使用。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">服务优化与改善：我们利用收集到的信息来监测和分析 APP
                        的运行状况、用户行为模式以及服务使用情况，以便及时发现并解决可能存在的问题，持续优化 APP 的性能、功能和用户界面设计，确保本 APP
                        能够更好地满足您的需求，并为您提供更安全、稳定、高效的服务环境。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">市场分析与研究：通过对大量用户的设备信息和软件安装列表进行综合分析，我们可以深入了解市场趋势、用户需求分布以及行业竞争态势，从而为我们的市场营销策略制定、产品研发方向确定以及业务决策提供有力的数据支持与参考依据，以便我们能够更好地适应市场变化，为您提供更具创新性和竞争力的产品与服务。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">信息共享与披露</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">1. 我们可能会将您的个人信息在本 APP
                        内部进行共享，以便各业务部门能够协同工作，为您提供更全面、连贯的服务体验。例如，营销部门可能会根据您的用户画像制定个性化的营销方案，而技术支持部门则可能利用您的设备信息来解决您在使用过程中遇到的技术问题</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.
                        在符合法律法规规定并获得您明确授权的情况下，我们可能会将您的部分个人信息与第三方合作伙伴进行共享，但仅会出于合法、正当、必要且明确告知您的目的进行共享，并且我们会要求第三方合作伙伴遵守严格的数据保护要求，确保您的个人信息安全。这些第三方合作伙伴可能包括但不限于广告投放平台、数据分析机构、供应商等，他们可能会利用您的个人信息为我们提供广告投放服务、数据分析服务或协助我们完成某些业务功能的实现。例如，我们可能会将您的设备信息和软件安装列表共享给广告投放平台，以便他们能够根据您的兴趣偏好为您精准投放广告，但我们会确保广告投放平台仅将这些信息用于广告投放目的，且在广告投放过程中不会泄露您的个人信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">信息存储与安全</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1. 信息存储：我</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">们将采取合理的措施存储您的个人信息，包括但不限于使用安全的服务器设施、数据库加密技术以及访问控制机制等，以确保您的个人信息在存储期间的安全性与完整性。我们会根据法律法规要求以及业务需要，确定个人信息的存储期限，并在存储期限届满后，及时删除或匿名化处理您的个人信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2. 信息安全：我</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">们高度重视您个人信息的安全保护，采取了一系列的安全技术与管理措施来防止您的个人信息被未经授权的访问、使用、修改、泄露或销毁。这些措施包括但不限于建立严格的信息安全管理制度、定期进行信息安全培训与教育、实施网络安全防护技术（如防火墙、入侵检测系统等）以及对数据处理活动进行监控与审计等。尽管我们已经采取了上述安全措施，但由于互联网环境的复杂性和不确定性，我们无法完全排除个人信息安全风险的存在。因此，我们建议您在使用本
                        APP 时，也应采取必要的个人信息保护措施，如妥善保管您的账号密码、避免在不安全的网络环境中使用本 APP 等。</span></p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">三</span><span>、我们如何使用cookie及其他同类技术</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">为确保平台正常运行，我们会在您的计算机或移动设备上存储名为cookie的数据文件。cookie通常包含用户身份标识符、城市名称以及一些其他字符。cookie主要的功能是便于您使用平台服务（功能），以及帮助平台统计独立访客数量等。运用cookie技术，我们能够为您提供更加周到的服务。我们不会将cookie用于本政策所述目的之外的任何用途。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">四</span><span>、我们如何共享、转让、公开披露您的个人信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享、转让的第三方无法重新识别此类信息的自然人主体。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(一)共享</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">我们会以高度勤勉义务对待您的信息。</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">除以下情形外，未经您同意，我们不会与除与关联方外的任何第三方公司、组织和个人分享您的个人信息</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">：</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.为实现特定功能而与业务合作伙伴共享</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">当软件服务提供商或系统服务提供商与我们联合为您提供服务时，当您需要使用地理位置功能时，为实现这一功能，我们可能会收集您的位置信息或相关设备信息（例如：IP地址、GPS位置、传感器、Android\_ID、硬件型号、操作系统版本号、国际移动设备身份识别码（IMEI）、网络设备硬件地址（MAC）及IDFA）。我们的授权合作伙伴包括以下类型：</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">(1)服务平台或服务提供商。窝窝投各产品现已接入或未来接入的第三方服务。当您选择使用该第三方服务时，您授权我们将该信息提供给第三方服务平台或服务提供商，以便其基于相关信息为您提供服务，包括认证服务提供商，当您绑定窝窝投与认证平台账号时，我们将弹出授权确认页面，在向您告知收集上述信息并得到您授权的情况下，我们可能会将您的个人信息提供给认证平台，用于审核您的个人信息；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">(2)软硬件/系统服务提供商。当第三方软硬件/系统服务或产品与窝窝投的服务或产品结合为您提供服务或产品时，在征得您授权后，我们会向第三方软硬件/系统服务提供商提供您必要的个人信息，以便您使用服务或产品，或用于我们分析服务或产品的使用情况，来提升您的使用体验。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">当您完成窝窝投平台认证商家的任务后选择提现时，您授权我们将您的支付宝账号信息提供给我们的业务合作伙伴福建众合共赢科技有限公司，包括您的姓名全称及支付宝账号。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(二)&nbsp;转让</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">我们不会将您的个人信息转让给关联公司外的任何公司、组织和个人，但以下情形除外：</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.事先获得您的明确授权或同意；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.满足法律法规、法律程序的要求或强制性的政府要求或司法裁决；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">如果我们或我们的关联公司涉及合并、分立、清算、资产或业务的收购或出售等交易，您的个人信息有可能作为此类交易的一部分而被转移，我们将确保该等信息在转移时的机密性，并要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</span>
                </p>
                <p></p>
                <p></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">五</span><span>、我们如何保存及保护您的个人信息</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(一)&nbsp;保存信息</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;信息存储</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您在使用窝窝投服务及产品期间，我们将持续为您保存您的个人信息。如果您注销账户账号或主动删除上述信息，我们将依据《中华人民共和国网络安全法》等相关法律法规的规定保存您的信息。在您注销帐户或主动删除上述信息后，我们不会再对您的个人信息进行商业化使用，但我们可能会对您的个人信息进行删除或匿名化处理后使用。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;保存地域</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">我们承诺，目前您的个人信息仅储存于中华人民共和国境内。如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;例外情况</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">一般而言，我们仅为实现目的所必需的合理时间保留您的个人信息，下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（1）为遵守法律法规等有关规定的适用；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（2）为遵守法院判决、裁定或其他法律程序的规定；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（3）为遵守相关政府机关或法定授权组织的要求；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（4）为执行相关服务协议或本政策维护社会公共利益；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（5）为保护我们及平台认证商家、其他用户或雇员的人身财产安全；</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">（6）其他合法权益所合理必需的用途。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">当我们的服务或产品发生停止运营的情形时，我们将按照法律规定向用户进行通知，通知方式包括但不限于消息推送、平台公告等，并在合理期限内删除或匿名化处理您的个人信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(二)&nbsp;保护措施</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全培训课程，加强员工对于保护个人信息重要性的认识。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;我们从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。同时，我们亦致力于不断提升我们的系统安全性能，以期能有效抵御各类非正常访问。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息（除非法律有强制的存留要求或双方另有约定）。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">4.&nbsp;互联网并非绝对安全的环境，使用平台服务或产品时，我们强烈建议您不要使用非平台推荐的通信方式发送您的信息。您可通过IM即时通讯服务与平台认证商家及其他用户建立联系和相互分享。当您通过IM即时通讯服务创建交流、分享时，您可自主选择沟通、分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">5.&nbsp;在使用IM即时通讯服务进行沟通时，请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账号或密码发生泄露，请您立即通过本政策的“联系我们”中公布的联系方式与我们联系，以便我们根据您的申请采取相应措施。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评论、沟通时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(三)&nbsp;安全事件通知</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;我们会制定网络安全事件应急预案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;个人信息泄露、毁损、丢失属于公司级特大安全事件，我们会负责定期组织工作组成员进行安全预案演练，防止此类安全事件发生。若一旦不幸发生，我们将按照最高优先级启动应急预案，在最短时间内追溯原因并减少损失。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时通过平台内部提醒、邮件、短信或电话等方式向您告知安全事件的基本情况和可能的影响、我们已采取或将要采取的处理措施、您可自主防范和降低的风险的建议、对您的补救措施等。我们将及时将事件相关情况通过上述方式告知您，难以逐一告知时我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">六</span><span>、您的权利</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(一)&nbsp;访问和修改您的个人信息</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;访问和修改昵称、头像、地区、性别、个人简介等。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;访问和修改实名信息，尚未完成实名认证的用户，可修改已经录入的信息。已经完成实名认证的用户，不能进行修改。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;访问和修改手机号，一经注册不能修改。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">4.&nbsp;如果您无法访问和修改该等个人信息，您可通过本政策的“联系我们”中公布的联系方式与我们联系。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">5.&nbsp;如果您希望了解在使用我们的服务和产品过程中产生的其他个人信息，请通过本政策的“联系我们”中公布的联系方式与我们联系，我们将视情况在与您沟通后提供适当的协助。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">6.&nbsp;您发现我们处理的关于您的个人信息有错误时，您有权对错误或不完整的信息作出更正或更新，您可通过上述段落中列明的方式提出更正或补充申请。为保障安全，我们将在您采取更正行为前对您的身份进行验证。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(二)&nbsp;删除您的个人信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">在以下情形中，您可向我们提出删除个人信息的请求，您可通过“（一）访问和修改您的个人信息”中列明的方式或本政策“联系我们”中公布的联系方式随时与我们联系：</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;如果我们违反法律法规或与您的约定收集、使用、与他人共享或转让您的个人信息；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;如果我们违反法律法规规定或与您的约定，公开披露您的个人信息，您有权要求我们立即停止公开披露的行为，并发布通知要求相关接收方删除相应的信息；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;我们没有征求您的明确同意，收集了您的个人信息；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">4.&nbsp;我们违反了与您的约定来使用和处理您的个人信息；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">5.&nbsp;您注销了窝窝投帐号、卸载或者不再使用我们的服务（或产品）；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">6.&nbsp;我们停止对您提供服务。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(三)&nbsp;改变授权范围</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;改变或撤回敏感信息权限</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您可在设备本身操作系统中关闭地理位置、通讯录、摄像头、麦克风等权限改变同意范围或撤回您的授权。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;拒绝接受推送及营销信息</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您可在手机设置关闭“推送通知”的方式拒绝接收广告信息（如手机设备支持该功能）。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;请您理解，特定的服务和功能将需要您的信息才能完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也将不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(四)&nbsp;注销您的账号</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您可直接申请注销账号，窝窝投将在用户提出注销申请的10个工作日内完成注销审核；通过审核的，窝窝投即刻永久性注销该账户；审核未通过的，窝窝投将提示用户未能通过的原因，若因用户在确认注销审核通过前删除软件而不知晓注销申请未通过的原因，由用户自行承担相应后果，具体操作流程及提示注意等相关内容以</span><span
                        style="font-family: var(--docx-minorEastAsia-font); color: rgb(0, 0, 255);">《窝窝投网络服务平台用户注册协议》</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">相关条款载明的为准。在您成功注销账号之后，我们将停止为您提供服务或产品，并根据法律的要求删除您的个人信息，或对其进行匿名化处理。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(五)&nbsp;提前获知产品和服务停止运营</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">窝窝投愿一直陪伴您，若因特殊原因导致平台被迫停止运营，我们将按照法律法规的要求，在服务及产品的主页面或平台公告形式或向您发送电子邮件或其他合适的能向您送达的方式通知您（无论您是否查阅或因您的原因未查阅），并将停止对您个人信息的收集，同时会按照法律规定对所持有的您的个人信息进行删除或匿名化处理等。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">(六)&nbsp;响应您的上述请求</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;为保障安全，在响应您的个性化要求之前，我们会要求您提供必要的书面请求，或以其他方式证明您的身份。我们可能会先要求您验证身份，然后再处理您的请求。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span>
                </p>
                <p></p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">七</span><span>、您的个人信息如何进行跨境转移</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">您的个人信息将只存储在位于中华人民共和国境内的服务器上，您的信息将不会被我们主动传输到境外。但您需要知晓，窝窝投网络服务平台上的商家包含跨国公司，其可能在境外使用窝窝投网络服务平台、将您的个人简介发送境外等，具体实践请见各该等企业的隐私政策。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">八</span><span>、本政策的更新</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">我们可能适时修订本政策内容。如该等变更会导致您在本政策项下权利的实质变化，我们将在变更生效前，通过系统推送、电子邮件、短信或平台公告等方式通知您。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">若您不同意该等变更应停止使用窝窝投服务或产品，或通过本政策公布的联系方式要求暂时封停您的账号。若您继续使用我们的服务或产品，即表示您同意受本政策后续修订版本的约束。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">本政策所指的实质变化包括但不限于：</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;个人信息共享、转让或公开披露的主要对象发生变化；</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;您参与个人信息处理方面的权利及其行使方式发生重大变化；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">4.&nbsp;其他可能对您的个人信息权益产生重大影响的变化时；</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">5.&nbsp;个人信息出境情况发生变更时。</span></p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">九</span><span>、联系我们</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">如果您对本政策及我们对您的个人信息的处理有任何疑问、意见、建议，请通过【</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">liuchen@wowotown.com】与我们联系。我们会在15日内对您的请求予以答复。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">十</span><span>、争议解决</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">本政策与</span><span
                        style="font-family: var(--docx-minorEastAsia-font); color: rgb(0, 0, 255);">《窝窝投网络服务平台用户注册协议》</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">共同构成您使用窝窝投服务的基本协议文件。本政策适用中华人民共和国法律法规。与本政策相关的争议，如果您对我们的回复或解决方案不满意，需要通过法律途径解决的，应将该争议提交至上海国际经济贸易仲裁委员会，其仲裁裁决是终局的。</span>
                </p>
                <p></p>
                <p class="it365-janqi-com_3"><span lang="en-US">十一</span><span>、附录：定义</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">本政策中使用的特定词语，具有如下含义：</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">1.&nbsp;我们：指</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">上海德益文智能科技有限公司</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">2.&nbsp;您或平台用户：指使用</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">上海德益文智能科技有限公司</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">运营的平台服务或产品的实名注册用户。</span></p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">3.&nbsp;窝窝投网络服务平台：指</span><span
                        style="font-family: var(--docx-minorEastAsia-font); font-weight: bold;">上海德益文智能科技有限公司</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">合法运营或管理的网络服务平台，包括但不限于网页版、桌面版及移动版软件客户端及小程序）。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">4.&nbsp;平台认证商家：指在窝窝投网络服务平台的实名注册商家。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">5.&nbsp;个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括个人基本信息、个人身份信息、个人生物识别信息、网络身份标识信息、个人健康生理信息、个人教育工作信息、个人财产信息、个人通信信息、联系人信息、个人上网记录、个人常用设备信息、个人位置信息等。为免疑义，个人信息包括但不限于个人敏感信息。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">6.&nbsp;个人信息主体：指个人信息所标识的自然人。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">7.&nbsp;个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。个人敏感信息包括个人财产信息、个人健康生理信息、个人生物识别信息。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">8.&nbsp;&nbsp;设备标识信息：指设备型号、操作系统版本、设备设置、Android\_ID&nbsp;、MAC地址及IMEI、IDFA、OAID及其他设备标识符。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);">9.&nbsp;&nbsp;位置信息：指IP地址、WiFi\_SSID、WI\-FI
                        BSSID、GPS传感器、位置（或精准定位和粗略定位（IOS版））、Wi\-Fi接入点、蓝牙和基站等信息。</span></p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">10.&nbsp;去标识化：指通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">11.&nbsp;匿名化：指通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。</span>
                </p>
                <p></p>
                <p><span
                        style="font-family: var(--docx-minorEastAsia-font);">12.&nbsp;中国或中华人民共和国境内：指中华人民共和国大陆地区，仅为本政策之目的，不包含香港特别行政区、澳门特别行政区和台湾地区。</span>
                </p>
                <p></p>
                <p><span style="font-family: var(--docx-minorEastAsia-font);"> 本政策最后更新于：2025-</span><span lang="en-US"
                        style="font-family: var(--docx-minorEastAsia-font);">11</span><span
                        style="font-family: var(--docx-minorEastAsia-font);">-24</span></p>
                <p></p>
            </article>
        </section>
    </div>
</template>

<script>
export default {
    name: "PrivacyAgreement",
    methods: {
        transmitTitle() {
            // eslint-disable-next-line no-undef
            changeTitle.postMessage("用户协议");
        },
    },
};
</script>

<style scoped>
.it365-janqi-com-wrapper {
    background: gray;
    padding: 30px;
    padding-bottom: 0px;
    display: flex;
    flex-flow: column;
    align-items: center;
}

.it365-janqi-com-wrapper>section.it365-janqi-com {
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    margin-bottom: 30px;
}

.it365-janqi-com {
    color: black;
    hyphens: auto;
    text-underline-position: from-font;
}

section.it365-janqi-com {
    box-sizing: border-box;
    display: flex;
    flex-flow: column nowrap;
    position: relative;
    overflow: hidden;
}

section.it365-janqi-com>article {
    margin-bottom: auto;
    z-index: 1;
}

section.it365-janqi-com>footer {
    z-index: 1;
}

.it365-janqi-com table {
    border-collapse: collapse;
}

.it365-janqi-com table td,
.it365-janqi-com table th {
    vertical-align: top;
}

.it365-janqi-com p {
    margin: 0pt;
    min-height: 1em;
}

.it365-janqi-com span {
    white-space: pre-wrap;
    overflow-wrap: break-word;
}

.it365-janqi-com a {
    color: inherit;
    text-decoration: inherit;
}

.it365-janqi-com svg {
    fill: transparent;
}

.it365-janqi-com {
    --docx-majorHAnsi-font: Calibri Light;
    --docx-minorHAnsi-font: Calibri;
    --docx-dk1-color: #000000;
    --docx-lt1-color: #FFFFFF;
    --docx-dk2-color: #44546A;
    --docx-lt2-color: #E7E6E6;
    --docx-accent1-color: #4874CB;
    --docx-accent2-color: #EE822F;
    --docx-accent3-color: #F2BA02;
    --docx-accent4-color: #75BD42;
    --docx-accent5-color: #30C0B4;
    --docx-accent6-color: #E54C5E;
    --docx-hlink-color: #0026E5;
    --docx-folHlink-color: #7E1FAD;
}

.it365-janqi-com span {
    font-family: 'Times New Roman', 宋体;
}

.it365-janqi-com p,
p.it365-janqi-com_1 {
    text-align: justify;
}

.it365-janqi-com p,
p.it365-janqi-com_1 span {
    font-family: var(--docx-minorHAnsi-font);
    min-height: 10.50pt;
    font-size: 10.50pt;
}

p.it365-janqi-com_2 {
    margin-top: 17.00pt;
    margin-bottom: 16.50pt;
    line-height: 2.40;
    text-align: justify;
}

p.it365-janqi-com_2 span {
    font-weight: bold;
    min-height: 22.00pt;
    font-size: 22.00pt;
    font-family: var(--docx-minorHAnsi-font);
}

p.it365-janqi-com_3 {
    margin-top: 13.00pt;
    margin-bottom: 13.00pt;
    line-height: 1.72;
    text-align: justify;
}

p.it365-janqi-com_3 span {
    font-family: Arial, 黑体;
    font-weight: bold;
    min-height: 16.00pt;
    font-size: 16.00pt;
}

p.it365-janqi-com_4 {
    margin-top: 13.00pt;
    margin-bottom: 13.00pt;
    line-height: 1.72;
    text-align: justify;
}

p.it365-janqi-com_4 span {
    font-weight: bold;
    min-height: 16.00pt;
    font-size: 16.00pt;
    font-family: var(--docx-minorHAnsi-font);
}

.it365-janqi-com table,
table.it365-janqi-com_5 td {
    padding-top: 0.00pt;
    padding-left: 5.40pt;
    padding-bottom: 0.00pt;
    padding-right: 5.40pt;
}

span.it365-janqi-com_7 {
    color: #0000FF;
    text-decoration: underline;
}
</style>
<style>
p.it365-janqi-com-num-1-0:before {
    content: "" counter(it365-janqi-com-num-1-0, simp-chinese-informal)"、";
    counter-increment: it365-janqi-com-num-1-0;
}

p.it365-janqi-com-num-1-0 {
    display: list-item;
    list-style-position: inside;
    list-style-type: none;
}

.it365-janqi-com-wrapper {
    counter-reset: it365-janqi-com-num-1-0 0;
}
</style>
